export default __webpack_public_path__ + "static/screen_erp_5-f92287735b68aeb79ed9a8a60df44bc6.png";